import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme, useMixin } from '@clds/component-theme';
import { Typography, TypographySize } from '@clds/typography';
import { blenderBackground } from '@clds/blender';
import { ButtonSize, ButtonTone, toBlenderProps } from '@clds/button';
import { Version, VersionName } from '..';
import { t } from '../CodeSnippetTheme';
import { SnippetVersionsMenu } from './SnippetVersionsMenu';
import { OverflowedVersion } from './OverflowedVersion';

export interface SnippetVersionPickerProps {
  versions: Version[];
  activeVersion: string | undefined;
  onVersionChange?: (version: VersionName) => void;
  size: ButtonSize;
  tone?: ButtonTone;
}

export const StyledText = styled(Typography)`
  height: 100%;
  display: flex;
  align-items: center;
  white-space: nowrap;
  user-select: none;

  background-color: ${blenderBackground};
  border-radius: ${globalTheme.spacing.xxs};
  padding: 0 ${globalTheme.spacing.xs};
`;

export const SnippetVersionPicker = styled<FC<SnippetVersionPickerProps>>(({ versions, activeVersion, onVersionChange, size, tone = 'plain' }) => {
  const typographySize = useMixin(t.header.sizeVariant[size].typographySize) as TypographySize;
  return (
    <>
      {versions?.length > 1 ? (
        <SnippetVersionsMenu versions={versions} langVersion={activeVersion} onVersionChange={onVersionChange} tone={tone} size={size} />
      ) : (
        activeVersion && (
          <StyledText
            type="regular"
            size={typographySize}
            data-test-specifier="version"
            {...toBlenderProps('unselected', 'normal', { variant: 'secondary', tone })}
          >
            <OverflowedVersion version={activeVersion} />
          </StyledText>
        )
      )}
    </>
  );
})``;
